module.exports = __webpack_public_path__ + "static/img/region_distribution_3.5da931f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/region_distribution_3.png
// module id = UEDU
// module chunks = 6